import React from "react";
import { motion } from "framer-motion";
import {
  LockClosedIcon,
  ClipboardDocumentListIcon,
  MapPinIcon,
  ServerStackIcon,
} from "@heroicons/react/24/outline";

const items = [
  {
    icon: LockClosedIcon,
    title: "Secure Access",
    desc: "AES-256 encryption & role-based permissions",
  },
  {
    icon: ClipboardDocumentListIcon,
    title: "Audit Trail",
    desc: "Every system action logged for transparency",
  },
  {
    icon: MapPinIcon,
    title: "GPS Accuracy",
    desc: "Anti-spoofing location checks for attendance",
  },
  {
    icon: ServerStackIcon,
    title: "Reliable System",
    desc: "99%+ internal uptime benchmark",
  },
];

export default function SystemStandardsStrip() {
  return (
    <section
      className="py-14 bg-gray-50 border-t border-gray-200"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-6">
        
        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.5 }}
              className="flex flex-col items-center"
            >
              <item.icon className="w-8 h-8 text-gray-700 mb-3" />

              <h4 className="text-base font-semibold text-gray-900">
                {item.title}
              </h4>

              <p
                className="text-sm text-gray-600 mt-1 leading-relaxed"
                style={{ fontFamily: "Roboto, sans-serif" }}
              >
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
